import React from 'react';
import { CreditCard, Percent, Calendar, PiggyBank } from 'lucide-react';

const LoanSubsidiesSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  if (!formData.includeLoanSubsidies) return null;

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CreditCard className="w-5 h-5 mr-2 text-purple-500" />
        Субсидирование процентной ставки
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Сумма кредита */}
        <div>
          <label htmlFor="loanAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма кредита
          </label>
          <input
            type="text"
            id="loanAmount"
            name="loanAmount"
            value={formData.loanAmount}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.loanAmount ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.loanAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.loanAmount}
            </p>
          )}
        </div>

        {/* Срок кредита */}
        <div>
          <label htmlFor="loanTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-1 text-purple-500" />
            Срок кредита (лет)
          </label>
          <input
            type="text"
            id="loanTerm"
            name="loanTerm"
            value={formData.loanTerm}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.loanTerm ? 'input-error' : ''}`}
            placeholder="Введите срок"
          />
          {errors.loanTerm && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.loanTerm}
            </p>
          )}
        </div>

        {/* Процентная ставка */}
        <div>
          <label htmlFor="loanRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Percent className="w-4 h-4 mr-1 text-purple-500" />
            Процентная ставка (%)
          </label>
          <input
            type="text"
            id="loanRate"
            name="loanRate"
            value={formData.loanRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.loanRate ? 'input-error' : ''}`}
            placeholder="Введите ставку"
          />
          {errors.loanRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.loanRate}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <PiggyBank className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              Информация о субсидировании кредитов
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              Государство может субсидировать значительную часть процентной ставки по кредитам для сельхозпроизводителей.
              Для кредитов с высокой ставкой субсидируется до 90% от ставки, а для льготных кредитов – до 60%. 
              Максимальный срок субсидирования зависит от цели кредита.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanSubsidiesSection;